import { FC, ChangeEvent, useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import StyledTabs, { StyledTab } from './StyledTabs'

interface TabsProps { };

const Tabs: FC<TabsProps> = () => {
    const classes = useStyles();
    const [value, setValue] = useState(0);

    const handleChange = (_: ChangeEvent<{}>, newValue: number) => {
      setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <StyledTabs value={value} onChange={handleChange}>
                <StyledTab label="Estructura" />
                <StyledTab label="Métricas" />
                <StyledTab label="Conversaciones" />
            </StyledTabs>
        </div>
    );
};

Tabs.defaultProps = { };

export default Tabs;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#fff",
  },
}));
